import React, {FC} from 'react';
import styled from 'styled-components';

import {KeyboardActionsEnum} from '../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {VisualParticipantModel} from '../../../models/api/visualParticipantModel';
import {CalendarEventData} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {CalendarsPanelId} from '../../../store/panels/panelStateBase';
import {CalendarEventViewerHeaderButtonsContainer} from './calendarEventViewerHeaderButtonsContainer';

/*
 * Props.
 */

export interface PopoverCalendarEventViewerHeaderProps {
  panelId: CalendarsPanelId;
  calendarEventData: CalendarEventData;
  visualParticipants: ReadonlyArray<VisualParticipantModel>;
  onEditClick: Handler;
  onRequestClose: Handler;
}

/*
 * Style.
 */

export const StyledPopoverHeaderDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid ${(p) => p.theme.greys.shade30};
  padding: 5px 8px 5px 16px;
`;

/*
 * Component.
 */

export const PopoverCalendarEventViewerHeader: FC<PopoverCalendarEventViewerHeaderProps> = (props) => {
  const theme = useUserTheme();
  const {panelId, calendarEventData, visualParticipants, onEditClick, onRequestClose} = props;

  return (
    <StyledPopoverHeaderDiv>
      <CalendarEventViewerHeaderButtonsContainer
        panelId={panelId}
        calendarEventData={calendarEventData}
        visualParticipants={visualParticipants}
        onEditClick={onEditClick}
        numberOfPrimaryButtons={4}
        onRequestClose={onRequestClose}
        shouldHandleKeyboardShortcuts
      >
        <IconButton
          iconName="close"
          onClick={onRequestClose}
          label={<Trans id="calendar-event-viewer-header-close">Close</Trans>}
          keyboardAction={KeyboardActionsEnum.CLOSE}
          color={theme.greys.shade80}
          hoverColor={theme.greys.shade80}
        />
      </CalendarEventViewerHeaderButtonsContainer>
    </StyledPopoverHeaderDiv>
  );
};
